import { render, staticRenderFns } from "./ConsumptionOzon.vue?vue&type=template&id=c685a036&"
import script from "./ConsumptionOzon.vue?vue&type=script&lang=js&"
export * from "./ConsumptionOzon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports